export const MAX_CAPTION_LINES = 2;

export const POSTGRID_POSTS_SIZE = 20;
